import { useState } from "react";
import Toast from "@/components/base/Toast";
import { useToast } from "@/hooks/useToast";
import { footerLinks, siteMeta } from "@/mocks/homeData";

export default function Footer() {
  const [email, setEmail] = useState("");
  const { message, show } = useToast();

  const handleSubscribe = () => {
    if (!email.trim()) {
      show("请先填写一个邮箱地址");
      return;
    }
    show("静态展示页面，订阅暂未接入");
  };

  return (
    <footer className="w-full bg-primary-950">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-user-search-line text-lg" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-background-50">{siteMeta.name}</span>
                <span className="mt-1 font-label text-[10px] tracking-[0.2em] text-primary-300">
                  {siteMeta.tagline}
                </span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-primary-100/80">
              只做人物脉络梳理：把当事人身份、背景与主角关系按可核实程度摊开，能查的写清楚，查不到的留白。
            </p>
            <p className="mt-4 font-label text-xs text-primary-200/70">
              内容更新于 {siteMeta.updated} · 页面配图均为匿名化示意图像
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-label text-xs tracking-[0.2em] text-primary-300">页面导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="font-label text-sm text-primary-100/80 transition-colors duration-200 hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="font-label text-xs tracking-[0.2em] text-primary-300">脉络更新提醒</h4>
            <p className="mt-4 text-sm leading-relaxed text-primary-100/80">
              人物关系有新增或修正时，会在这里同步一次摘要。
            </p>
            <div className="mt-4 flex flex-col gap-2 sm:flex-row">
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                placeholder="your@email.com"
                className="min-w-0 flex-1 rounded-md border border-primary-700/50 bg-primary-900/60 px-3.5 py-2.5 font-label text-sm text-background-50 outline-none transition-colors duration-200 placeholder:text-primary-300/60 focus:border-primary-400"
              />
              <button
                type="button"
                onClick={handleSubscribe}
                className="cursor-pointer whitespace-nowrap rounded-md bg-background-50 px-4 py-2.5 font-label text-sm font-medium text-primary-950 transition-colors duration-200 hover:bg-primary-100"
              >
                订阅更新
              </button>
            </div>
            <p className="mt-3 font-label text-[11px] text-primary-200/60">
              演示环境 · 邮箱不会被真实收集
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-800/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-primary-200/70">
            © {new Date().getFullYear()} {siteMeta.name} · 人物向单页梳理
          </p>
          <p className="font-label text-xs text-primary-200/70">
            本页内容仅作公开信息整理，不指向任何具体个人
          </p>
        </div>
      </div>
      <Toast message={message} />
    </footer>
  );
}